var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sentences),function(sentence,index){return _c('span',{key:index,style:(_vm.reactionInlineStyle(_vm.reactions[index]))},[_vm._v(_vm._s(sentence)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }